import img1 from "../../src/images/career1.png"
import img2 from "../../src/images/blood1.jpg"
import img3 from "../../src/images/jewellery.jpg"
import img4 from "../../src/images/store1.png"
import img5 from "../../src/images/pawsome_care.jpg"


export const project = [
    {
        title : "CareerMatch",
        desc : "CareerMatch is a machine learning–powered job recommendation system that uses a Random Forest classifier to predict the most suitable job roles for users based on their qualifications, skills, experience level, and personal preferences.The model is trained on structured user–job datasets and learns patterns in how specific combinations of skills and qualifications align with different job categories.Based on a user’s input profile, the Random Forest model predicts the best-fitting job role and recommends relevant opportunities with high accuracy.",
        live : "",
        code : "",
        image : img1
    },
    {
        title : "LifeLink",
        desc : "LifeLink is a blood bank management platform designed to simplify the connection between donors, patients, and administrators. The system manages blood availability, donor registrations, and patient requests in a structured and efficient way.",
        live : "https://blood-bank-django-vmra.onrender.com/",
        code : "https://github.com/Rohini6697/blood-bank-django",
        image : img2
    },
    {
        title : "Dennel",
        desc : "Dennel is a modern, user-friendly ecommerce jewellery application designed to bring the luxury of fine jewellery shopping right to your fingertips. The app offers a smooth browsing experience with beautifully curated collections that include gold, silver, diamond, and fashion jewellery.",
        live : "https://jewelry-app-pi.vercel.app/",
        code : "https://github.com/Rohini6697/Jewelry-app",
        image : img3
    },
    {
        title : "Organic Store",
        desc : "Organic Store is a clean, eco-friendly ecommerce application designed to provide customers with access to high-quality organic products from trusted sources. The app offers a smooth, intuitive shopping experience where users can browse a wide range of natural groceries, fresh fruits, vegetables, dairy items, handmade products, and eco-friendly household essentials.",
        live : "",
        code : "https://github.com/arathyrajeesh/ecommerce-mini-project",
        image : img4
    },
    {
        title : "Pawsome Care",
        desc : "PawsomeCare is a modern, user-friendly pet care application designed to simplify pet management for owners. The platform offers a seamless experience to manage pet profiles and schedule appointments with ease. It also includes smart features like AI-based guidance, ensuring better care and well-being for pets—all in one place.",
        live : "https://pawsomecare.onrender.com",
        code : "https://github.com/Rohini6697/pawsomecare",
        image : img5
    }
]